import React, { useState } from 'react';

const CrmForm = ({ bannerForm }) => {
	const [currentClass, setCurrentClass] = useState('');

	const handleSubmit = (event) => {
		event.preventDefault();
		setCurrentClass('is-processing');

		setTimeout(function () {
			sendLeadToSessionLayer(event.target[0].value);
		}, 1500);
	};

	const generateGUID = () => {
		const fourChars = function () {
			return Math.floor((1 + Math.random()) * 0x10000)
				.toString(16)
				.substring(1);
		};

		const eightChars = function () {
			return fourChars() + fourChars();
		};

		const twelveChars = function () {
			return fourChars() + fourChars() + fourChars();
		};

		return eightChars() + '-' + fourChars() + '-' + fourChars() + '-' + fourChars() + '-' + twelveChars();
	};

	const sendLeadToSessionLayer = (email) => {
		try {
			const lead = Object.assign({}, window.sessionLayer.leadHandler.lead.getData());
			lead.Dynamic_Marketing_Comment__c = JSON.stringify(lead);
			lead.Email = email;
			lead.Marketing_Partner__c = 'notification-bar';

			// if there is already a session generate new gid, lead id,
			// and visitor id to prevent upsert
			// TODO: figure out a way to reset sessionLayer session instead
			if (!window.sessionLayer.session.isNewSession()) {
				lead.GID__c = '001.' + generateGUID();
				lead.Lead_ID__c = 'USA-' + generateGUID();
				lead.Visitor_Id__c = generateGUID();
			}

			window.sessionLayer.leadHandler
				.submitToLeadHandler(lead)
				.then(function () {
					setCurrentClass('is-success');
					console.log(lead.GID__c + ' succesfully submitted to lead handler');
					window.sessionLayer.gtm.push({
						event: 'email.submit'
					});
				})
				.catch(function (error) {
					throw new Error(error);
				});
		} catch (error) {
			setCurrentClass('is-error');
			console.error(error);
		}
	};

	return (
		<form
			className={`c-crm-signup-form ${currentClass && currentClass} ${bannerForm && 'c-crm-signup-form--banner'}`}
			onSubmit={handleSubmit}
		>
			<input type="email" name="email" className="c-crm-signup-form__input" placeholder="Email" required />
			<button type="submit" className="c-crm-signup-form__submit">
				<span className="c-crm-signup-form__submit-copy">Get Guide</span>
				<div className="c-crm-signup-form__submit-loader"></div>
			</button>
			<p className="c-crm-signup-form__error-txt">Error! Try again later.</p>
			<p className="c-crm-signup-form__success-txt">Your guide is on the way!</p>
		</form>
	);
};

export default CrmForm;
